/* eslint-disable no-restricted-globals */
import Image from "next/image";
import React from "react";

const FallbackErrorPage = () => (
	<div id="error-page">
		<div className="error-content-container">
			<div className="fd-logo-container">
				<Image
					id="fd-logo"
					src="https://image.femaledaily.com/web-assets/icon/logo-femaledaily.svg"
					alt="logo-fd"
					width={132}
					height={24}
				/>
			</div>
			<div className="error-content-container__left">
				<h2 className="error-page__title mt-0">500. Error</h2>
				<h4 className="error-page__subtitle fd-font-h4 mt-0">
					Kami sedang perbaiki, ya. Silakan coba lagi nanti.
				</h4>
				<p className="error-page__description fd-font-body-lg-regular mt-0 mb-5">
					Kami sedang perbaiki, ya. Silakan coba lagi nanti.
				</p>
				<button
					className="link-btn--primary fd-border-radius-4 fd-font-h5 px-4 py-2"
					onClick={() => location.reload()}
					type="button"
				>
					Refresh Halaman
				</button>
			</div>
			<div className="error-content-container__right">
				<Image
					src="https://image.femaledaily.com/dyn/420/error-page/error-figure.jpg"
					alt="error-figure"
					quality={100}
					layout="fill"
				/>
			</div>
		</div>
		<style jsx>
			{`
			.error-content-container__left {
				grid-area: error-content-container__left;
			}

			.error-content-container__right {
				grid-area: error-content-container__right;
				width: 372px;
				height: 302px;
				position: relative;
				top: 50%;
				transform: translateY(-50%);
			}

			.fd-logo-container {
				grid-area: fd-logo-container;
			}

			.error-content-container {
				display: grid;
				grid-template-rows: 24px 1fr;
				grid-row-gap: 2.5rem;
				grid-template-columns: auto 1fr;

				grid-column-gap: 7.5rem;
				grid-template-areas:
					'fd-logo-container error-content-container__right'
					'error-content-container__left error-content-container__right'
					'error-content-container__left error-content-container__right';
			}

			.link-btn--primary {
				cursor: pointer;
				transition: all 0.2s ease;
				border-width: 0.063rem;
				border-style: solid;
				height: 40px;
				box-sizing: border-box;
				background-color: #db284e;
				color: #ffffff;
				border-color: #db284e;
				display: inline-block;
			}

			#error-page {
				display: flex;
				align-items: center;
				justify-content: center;
				height: 100vh;
				max-width: calc(100% - 70px);
				margin: 0 auto;
			}

			.error-content-container__right {
				max-width: 366px;
			}

			.error-page__title {
				margin-bottom: 2.5rem;
				font-family: Poppins;
				font-size: 32px;
				font-style: normal;
				font-weight: 600;
				line-height: 48px; /* 150% */
				text-transform: capitalize;
			}

			.error-page__subtitle,
			.error-page__description {
				margin-bottom: 1.25rem;
			}

			@media (max-width: 768px) {
				.error-content-container {
					display: grid;
					grid-template-columns: 1fr;
					grid-template-rows: auto 1fr auto;
					grid-template-areas:
						'fd-logo-container'
						'error-content-container__right'
						'error-content-container__left';
					text-align: center;
					grid-row-gap: auto;
				}

				.error-content-container__left {
					text-align: center;
					max-width: unset;
				}

				.error-content-container__right {
					margin: auto;
					width: 246px;
					height: 200px;
				}

				.error-page__title,
				.error-page__subtitle,
				.error-page__description {
					margin-bottom: 1rem;
				}
			}
		`}
		</style>
	</div>
);

export default FallbackErrorPage;
